export default "__VITE_ASSET__DpD3k$p6__"